import io from 'socket.io-client'
import {app, flags} from './app'

export const fabric = io(flags.urlFabric.concat('/tv?admin=true'))

/** Send the events to fabric layer */
app.ports.toFabric.subscribe(
  function (obj) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[admin -> fabric]', obj.event, obj.payload)
    }
    // console.log("test",fabric,flags.urlFabric.concat('/tv?admin=true'))
    // console.log("Emit Payload",obj.event, obj.payload)
    fabric.emit(obj.event, obj.payload)
  }
)

const eventList = [
  'connect',
  'disconnect',
  'reconnect',
  'reconnecting',

  // device activation
  'RESP_DEVICE_ID',
  'INVALID_ACTIVATION_CODE',
  'ACK_SELECT_SCHOOL',
  'ACK_SELECT_CATEGORIES',
  'ACK_SELECT_SERVING_LINES',
  'ACK_SELECT_NAME',
  'RESP_ACTIVATE_DEVICE',

  // connection
  'DEVICE_ONLINE',
  'DEVICE_OFFLINE',
  'RESP_ADMIN_CONNECT',
  'RESP_DEVICE_INFO',

  // Screenshot
  'RESP_SCREENSHOT',

  // Schedules
  'RESP_ALL_SCHEDULES',
  'RESP_CURR_SCHEDULE',

  // Template
  'RESP_TEMPLATE',
  'RESP_AVAILABLE_TEMPLATES',

  // Status Bar
  'RESP_STATUS_BAR_THEME',

  // backup
  'RESP_IMPORT_TEMPLATES',
  'SYNC_TEMPLATES_SUCCESS',
  'RESP_IMPORT_SCHEDULES',
  'SYNC_SCHEDULES_SUCCESS',
  'RESP_IMPORT_STATUS_BAR_THEME',
  'SYNC_STATUS_BAR_THEME_SUCCESS',
  'RESP_BACKUP_DEVICE_SUCCESS',
  'RESP_BACKUP_DEVICE_FAIL',

  // data
  'SAVE_OK_SERIAL_NUMBER',
  'SAVE_ERR_SERIAL_NUMBER',
  'SAVE_ERR_SERIAL_NUMBER_DESC',
  'RESP_OK_SERIAL_NUMBER',
  'RESP_ERR_SERIAL_NUMBER',
  'OK_MANIFEST',
  'ERR_MANIFEST',
  'RESP_CPU_INFO',
  'RESP_MEM_INFO',
  'RESP_SCREENSAVER',
  'PUBLISH_TEMPLATE_SUCCESS'
]

eventList.map(event => fabric.on(event, payload => {  
  if (event === "RESP_ALL_SCHEDULES") {
    let data = payload["@@data"];
    if (!("supper" in data)) {
      let endtime = {
        hour: 10,
        minute: 0,
      };
      let startTime = {
        hour: 18,
        minute: 0,
      };
      if (data.breakfast) {
        let breakfast = data.breakfast;
        endtime = breakfast.startTime;
      }
      if (data.lunch) {
        let lunch = data.lunch;
        startTime = lunch.endTime;
      }
      let newObj = {
        name: "Supper",
        isEnabled: true,
        template: "Singularity",
        startTime: startTime,
        endTime: endtime,
        menuPlanning: {
          mealType: "supper",
          servingLines: ["All lines"],
        },
      };
      Object.assign(data, { supper: newObj });
    }
  }
  app.ports.fromFabric.send({
    event,
    payload
  })
}))